import React from 'react';

function ImagePreviewIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_2840_1889" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2840_1889)">
        <path
          d="M4.67956 16.6667C4.29595 16.6667 3.97567 16.5382 3.71873 16.2813C3.46179 16.0243 3.33331 15.7041 3.33331 15.3205V4.67962C3.33331 4.29601 3.46179 3.97574 3.71873 3.71879C3.97567 3.46185 4.29595 3.33337 4.67956 3.33337H15.3204C15.704 3.33337 16.0243 3.46185 16.2812 3.71879C16.5382 3.97574 16.6666 4.29601 16.6666 4.67962V15.3205C16.6666 15.7041 16.5382 16.0243 16.2812 16.2813C16.0243 16.5382 15.704 16.6667 15.3204 16.6667H4.67956ZM6.9231 13.75H13.2052C13.3398 13.75 13.438 13.6897 13.5 13.569C13.5619 13.4483 13.5534 13.3291 13.4744 13.2115L11.7916 10.9505C11.719 10.8606 11.6293 10.8157 11.5225 10.8157C11.4155 10.8157 11.3257 10.8606 11.2531 10.9505L9.3429 13.3655L8.15373 11.928C8.08109 11.8489 7.99408 11.8094 7.89269 11.8094C7.79116 11.8094 7.70408 11.8543 7.63144 11.944L6.66977 13.2115C6.58005 13.3291 6.56616 13.4483 6.6281 13.569C6.69019 13.6897 6.78852 13.75 6.9231 13.75Z"
          fill="#CACED5"
        />
      </g>
    </svg>
  );
}

export default ImagePreviewIcon;
